import { render, staticRenderFns } from "./updPwd.vue?vue&type=template&id=ac7bf28e&"
import script from "./updPwd.vue?vue&type=script&lang=js&"
export * from "./updPwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports